var map = {
	"./android.svg": 1247,
	"./bg-home.webp": 1201,
	"./ebill-phone.webp": 5934,
	"./ebill.webp": 3995,
	"./hand.svg": 2462,
	"./home-right.webp": 795,
	"./home.webp": 2803,
	"./ios.svg": 2550,
	"./meters-image-consumption.webp": 4217,
	"./meters-image-manage.webp": 127,
	"./meters-image-measurement.webp": 4020,
	"./meters-image-register.webp": 8171,
	"./qr.svg": 5351,
	"./reports-image-chat.webp": 7603,
	"./reports-image-description.webp": 8649,
	"./reports-image-hydro.webp": 1031,
	"./reports-image-hydro1.webp": 6186,
	"./reports-image-map.webp": 385,
	"./reports-image-upload.webp": 9549,
	"./smartville.png": 6953,
	"./video.webp": 9350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;